import {
    SocialCreditCreateInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit.create-input';
import {
    SocialCreditContextInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit-context.input';
import {
    SocialCreditObject, SocialCreditGridObject, SocialCreditContextObject,
} from '@libs/types/src/services/object-type/folder/social-credit.object';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    SocialCreditCategoryCreateInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit-category.create-input';
import {
    SocialCreditCategoryUpdateInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit-category.update-input';
import {
    SocialCreditCategoryGridObject, SocialCreditCategoryObject,
} from '@libs/types/src/services/object-type/service/social-credit-category.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';
import {
    SocialCreditWorkPaymentsObject,
} from '@libs/types/src/services/object-type/folder/social-credit-work-payments.object';
import {
    SocialCreditUpdateInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit.update-input';
import {
    SocialCreditPurchaseInput,
} from '@libs/types/src/services/input-type/social/social-credit/social-credit.purchase-input';

@Injectable({ providedIn: 'root' })
export class SocialCreditGqlService extends GqlServiceV2 {

    public getSocialCreditCategories(input: GridInput | null, frag: string) {
        return this.query<SocialCreditCategoryGridObject>(
            `
                query($input: GridInput) {
                    socialCreditCategory {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialCreditCategory(input: SocialCreditCategoryCreateInput, frag: string) {
        return this.mutate<SocialCreditCategoryObject>(
            `
                mutation($input: SocialCreditCategoryCreateInput!) {
                    socialCreditCategory {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateSocialCreditCategory(input: SocialCreditCategoryUpdateInput, frag: string) {
        return this.mutate<SocialCreditCategoryObject>(
            `
                mutation($input: SocialCreditCategoryUpdateInput!) {
                    socialCreditCategory {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialCreditCategory(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialCreditCategory {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getSocialCredits(input: GridInput | null, frag: string) {
        return this.query<SocialCreditGridObject>(`
            query($input: GridInput) {
                socialCredit {
                    filter(input: $input) {
                        ${filterFrag}
                        items { ${frag} }
                    }
                }
            }
        `, { input });
    }

    public getSocialCreditBalance(input: IdInput) {
        return this.query<number>(`
            query($input: IdInput!) {
                socialCredit { balance(input: $input) }
            }
        `, { input });
    }

    public getSocialCreditContext(input: SocialCreditContextInput, frag: string) {
        return this.query<SocialCreditContextObject>(`
            query($input: SocialCreditContextInput!) {
                socialCredit { context(input: $input) { ${frag} } }
            }
        `, { input });
    }

    public createSocialCredit(input: SocialCreditCreateInput, frag: string) {
        return this.mutate<SocialCreditObject>(`
            mutation($input: SocialCreditCreateInput!) {
                socialCredit { create(input: $input) { ${frag} } }
            }
        `, { input });
    }

    public deleteSocialCredit(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                socialCredit { delete(input: $input) { ${frag} } }
            }
        `, { input });
    }

    public getSocialCreditWorkPayments(input: IdInput, frag: string) {
        return this.query<SocialCreditWorkPaymentsObject>(`
            query($input: IdInput!) {
                socialCredit { workPayments(input: $input) { ${frag} } }
            }
        `, { input });
    }

    public updateSocialCredit(input: SocialCreditUpdateInput, frag: string) {
        return this.mutate<SocialCreditObject>(`
            mutation($input: SocialCreditUpdateInput!) {
                socialCredit { update(input: $input) { ${frag} } }
            }
        `, { input });
    }

    public purchaseSocialCredit(input: SocialCreditPurchaseInput, frag: string) {
        return this.mutate<SocialCreditObject>(`
            mutation($input: SocialCreditPurchaseInput!) {
                socialCredit { purchase(input: $input) { ${frag} } }
            }
        `, { input });
    }

}
